module.exports = __webpack_public_path__ + "img/img_index_thumb_sms_intro_3.8c67728d.jpg";